export default "__VITE_ASSET__9c30dd2c__"